import {
    produceAxios1,
    getAction,
    deleteAction,
    putAction,
    postAction,
    httpAction,
    fromDataPostAction,
    fromDataPostActionMultipart,
  } from "@/api/manage";
export const inspectionRecordAdd = (params) => postAction('/jksaas-produce/produce/quality/inspectionRecord/add', params)
// 质检任务编辑接口
export const inspectionTask = (params) => postAction('/jksaas-produce/produce/quality/inspectionTask/edit', params)
export const inspectionTaskId = (params) => getAction('/jksaas-produce/produce/quality/inspectionTask/queryById', params)
